import React from "react";
import { Container, Col, Row, Image, Button } from "react-bootstrap";
import Guid1 from "../assets/img/Guid1.jpeg"
import Guid2 from "../assets/img/Guid2.jpeg"
import Guid3 from "../assets/img/Guid3.jpeg"
import Guid4 from "../assets/img/Guid4.jpeg"
import Guid5 from "../assets/img/Guid5.jpeg"
import Guid6 from "../assets/img/Guid6.jpeg"
import { useNavigate } from "react-router-dom";

function AppGuide(props) {
  const navigate = useNavigate();

  const backHandler = () => {
    navigate("/");
  }
  return (
    <div>
      <Container >
        <Row className="justify-content-center pt-5">
          <Col xs={12} lg={10} className="text-center rgc-title">
            <div className="d-flex flex-column">
              <div className="p-2">
                <Image src={Guid1} className="img-fluid" alt="Guid1" />
              </div>
              <div className="p-2">
                <Image src={Guid2} className="img-fluid" alt="Guid2" />
              </div>
              <div className="p-2">
                <Image src={Guid3} className="img-fluid" alt="Guid3" />
              </div>
              <div className="p-2">
                <Image src={Guid4} className="img-fluid" alt="Guid4" />
              </div>
              <div className="p-2">
                <Image src={Guid5} className="img-fluid" alt="Guid5" />
              </div>
              <div className="p-2">
                <Image src={Guid6} className="img-fluid" alt="Guid6" />
              </div>
              <div className="p-2">
                <Button
                  type="submit"
                  className="btn-fill m-1 rgc-back-btn"
                  onClick={backHandler}
                  variant="btn btn-primary"
                >
                  <i className='fas fa-share rgc-back-icon'></i>
                  <span>بازگشت</span>
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AppGuide;
